import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const KEY = (oid) => `iep-claim-${oid}`;
export const saveClaim = (oid, claim) => { try { if (oid && claim) localStorage.setItem(KEY(oid), claim); } catch (e) { /* sem armazenamento */ } };
const readClaim = (oid) => { try { return localStorage.getItem(KEY(oid)) || ""; } catch (e) { return ""; } };

/** Depois do pagamento: quem comprou neste navegador entra direto para criar a senha (sem esperar o e-mail). */
export function EnterAfterPurchase({ orderId, email }) {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const claim = readClaim(orderId);
  const go = async () => {
    setBusy(true);
    for (let i = 0; i < 5; i++) {
      try {
        const r = await api.post(`/public/sale/order/${orderId}/enter`, { claim });
        try { localStorage.removeItem(KEY(orderId)); } catch (e) { /* */ }
        if (r.data.login) { navigate("/login", { replace: true }); return; }
        setUser(r.data); window.location.assign("/primeiro-acesso"); return;
      } catch (e) {
        if (e.response?.status === 409 && i < 4) { await new Promise((ok) => setTimeout(ok, 2500)); continue; }
        toast.error(formatApiError(e.response?.data?.detail)); setBusy(false); return;
      }
    }
  };
  return (
    <div className="space-y-2" data-testid="enter-after-purchase">
      {claim && (
        <Button onClick={go} disabled={busy} className="w-full h-12 text-white font-semibold" style={{ background: "#1E9E2A" }} data-testid="enter-now">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Criar minha senha e acessar agora"}
        </Button>
      )}
      <p className="text-xs text-slate-500">{claim ? "Ou use" : "Use"} o link que enviamos para <strong>{email || "o e-mail informado"}</strong> (confira também a caixa de Spam e Promoções).</p>
      <Button variant="outline" onClick={() => navigate("/login")} className="w-full">Já criei minha senha · Entrar</Button>
    </div>
  );
}
